<template>
    <div class="filter-wrap" v-if="brands.length">
        <div class="box">
            <h4>{{ title }}</h4>

            <div class="custom-checkbox js-brand"
                 v-for="brand in brands.slice(0, 5)"
                 v-bind:key="brand.id"
            >
                <label>
                    <input type="checkbox"
                           name="brands[]"
                           :value="brand.id"
                           @change="$emit('onBrandChanged')"
                    >
                    <span class="check"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg></span>
                    <span class="label">{{ brand.name }}</span>
                </label>
            </div>

            <div class="custom-checkbox js-brand d-none"
                 v-for="brand in brands.slice(5)"
                 v-bind:key="brand.id"
            >
                <label>
                    <input type="checkbox"
                           name="brands[]"
                           :value="brand.id"
                           @change="$emit('onBrandChanged')"
                    >
                    <span class="check"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg></span>
                    <span class="label">{{ brand.name }}</span>
                </label>
            </div>
        </div>

        <div class="divider"
             v-if="brands.length > 5 && !allVisible"
             @click="removeClassBySelector('.js-brand', 'd-none'); allVisible = true"
        >
            <h5>
                <span>{{ allBrands }}</span>
            </h5>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'

import emitter from '../../utils/emitter'
import { removeClassBySelector } from '../../functions/removeClassBySelector'

export default defineComponent({

    props: [
        'title',
        'allBrands',
        'brands'
    ],

    setup() {

        const allVisible = ref(false)

        onMounted( () => {

            emitter.on('setValuesFromParameters', ({brands}) => {
console.log(brands);
                if ( brands && brands.length > 0  )
                    handleCheckedInputs(JSON.parse(brands))
            })
        })

        function handleCheckedInputs(Ids) {
            Array.from(document.querySelectorAll('.js-brand input')).forEach( (input) => {
                if ( Ids.includes(input.value) )
                    input.checked = true
            })
        }

        return {
            handleCheckedInputs,
            allVisible,
            removeClassBySelector
        }
    }
})
</script>
